// extracted by mini-css-extract-plugin
export default {"main":"styles_main__7tTMK","cups":"styles_cups__8k8V5","coffee":"styles_coffee__5UEcP","water":"styles_water__8EL0m"};